import type { ListItem } from "../../components/List/List"
import { CustomerEntity } from "../Customer/CustomerEntity"
import { MemoryClass } from "./MemoryClass"
import { ECustomerPaymentType } from "../../Enum/ECustomerPaymentType"

export class CustomerMemory extends MemoryClass<CustomerEntity> {
  setList(items: CustomerEntity[]): void {
    this.listData = [...items].sort((a, b) => {
      if (a.isDefaultCustomer !== b.isDefaultCustomer) {
        return a.isDefaultCustomer ? -1 : 1
      }

      return a.personEntity.name.localeCompare(b.personEntity.name)
    })
  }

  protected cloneEntity(item: CustomerEntity): CustomerEntity {
    return new CustomerEntity({ ...item })
  }

  getListCards(all: boolean) {
    var cards: ListItem[] = []

    let count = 0

    this.listData.forEach((ss) => {
      if (all || ss.status === ECustomerPaymentType.WithOutDebit) {
        cards.push(this.getCard(ss, count))
      }
    })

    count++

    return cards
  }

  getCard(ss: CustomerEntity, count: number): ListItem {
    const withoutDebit = ss.status === ECustomerPaymentType.WithOutDebit

    const isDefaultCustomer = ss.isDefaultCustomer

    const hasAwards = ss.awardManagers?.length > 0

    const hasAwardToTake = ss.awardManagers?.some((a) => a.hasAwardToTake)

    return {
      isDisable: !withoutDebit,
      id: ss.id,
      title: ss.personEntity.name,
      linkImage: "",
      index: count,
      dataFilter: [ss.personEntity.name, ss.personEntity.cpf, ss.personEntity.rg],
      children: (
        <div
          className={`relative flex items-center justify-between p-3 rounded-2xl transition-all duration-300 ${
            isDefaultCustomer
              ? "border-2 border-sky-300 bg-gradient-to-r from-white to-sky-100 shadow-sm shadow-amber-100"
              : withoutDebit
                ? "bg-white"
                : "bg-red-50 border border-red-200"
          }`}
        >
          <div className="flex items-center gap-4">
            <div
              className={`relative w-12 h-12 flex items-center justify-center rounded-full text-white text-lg font-semibold
          ${
            withoutDebit
              ? hasAwardToTake
                ? "bg-yellow-500"
                : hasAwards
                  ? "bg-orange-500"
                  : "bg-blue-500"
              : "bg-gray-800"
          }
        `}
            >
              {ss.personEntity.name.charAt(0).toUpperCase()}

              {hasAwardToTake && (
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full animate-pulse" />
              )}
            </div>

            <div className="flex flex-col">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-gray-800 text-base">{ss.personEntity.name}</span>

                {isDefaultCustomer && <span className="text-amber-600 text-sm">⭐</span>}

                {hasAwards && !hasAwardToTake && <span className="text-orange-500 text-sm">🏆</span>}
              </div>

              <span className="text-sm text-gray-500">
                {isDefaultCustomer ? "Cliente operacional da casa" : `CPF: ${ss.personEntity.cpf || "—"}`}
              </span>

              {!withoutDebit && <span className="text-xs font-bold text-red-600 mt-1">⚠ Cliente com débito ativo</span>}

              {!hasAwardToTake && hasAwards && (
                <span className="text-xs font-bold text-orange-600 mt-1">
                  🎯 Participando de {ss.awardManagers.length} prêmio(s)
                </span>
              )}
            </div>
          </div>

          <div className="flex flex-col items-end gap-2">
            {withoutDebit ? (
              <span className="px-3 py-1 text-xs font-semibold rounded-full bg-green-100 ring-2 ring-green-400 text-green-700">
                Sem Débito
              </span>
            ) : (
              <span className="px-3 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-600">Com Débito</span>
            )}

            {hasAwardToTake && (
              <span className="px-3 py-1 text-xs font-bold rounded-full ring-2 ring-yellow-500 text-yellow-900 shadow-sm">
                🎁 Resgatar
              </span>
            )}
          </div>
        </div>
      ),
    }
  }

  protected getItemId(item: CustomerEntity): number {
    return item.id
  }
}
